import { useCallback, useEffect } from "react";
import { useBeforeUnload, useBlocker, type BlockerFunction } from "react-router-dom";

export function useUnsavedChanges(dirty: boolean): void {
  const blocker = useBlocker(useCallback<BlockerFunction>(({ currentLocation, nextLocation }) => dirty && (
    currentLocation.pathname !== nextLocation.pathname || currentLocation.search !== nextLocation.search
  ), [dirty]));
  useBeforeUnload(useCallback(event => {
    if (dirty) { event.preventDefault(); event.returnValue = ""; }
  }, [dirty]));
  useEffect(() => {
    if (blocker.state !== "blocked") return;
    if (window.confirm("Discard your unsaved changes?")) blocker.proceed();
    else blocker.reset();
  }, [blocker]);
}
